import { Tag } from "antd";

export default function StatusVisit({ status }: { status: number }) {
  return (
    <Tag
      className={`rounded-full! py-1! px-3! text-14-regular! ${
        status === 2
          ? "text-success-500! bg-success-50! border-success-200!"
          : "text-error-500! bg-error-50! border-error-200!"
      }`}
    >
      {status === 2 ? "نمایش" : "عدم نمایش"}
    </Tag>
  );
}
